import { DeployLayout } from "@/components/flow/deploy/Layout";
import { DeploySidebarContent } from "@/components/flow/deploy/Steps/Deploy/SidebarContent";
import { DeployVisualAreaContent } from "@/components/flow/deploy/Steps/Deploy/VisualAreaContent";
import { ImproveModal } from "@/components/flow/deploy/Steps/Improve";
import { ModelPage } from "@/components/flow/deploy/Steps/Model/ModelPage";
import { ImproveContextProvider } from "@/contexts/ImproveProvider";
import { DeploySteps } from "@/types/flows";
import { useFlowState } from "@/hooks/useFlowState";

export const WorkflowPage = () => {
    const { step } = useFlowState();

    switch (step) {
        case DeploySteps.DEPLOY:
            return (
                <DeployLayout
                    Sidebar={<DeploySidebarContent />}
                    VisualArea={<DeployVisualAreaContent />}
                />
            );
        case DeploySteps.IMPROVE:
            return (
                <ImproveContextProvider>
                    <ImproveModal />
                </ImproveContextProvider>
            );
        case DeploySteps.MODEL:
            return <ModelPage />;
        default:
            throw new Error(`Invalid step: ${step}`);
    }
};
